import React, { useState, useEffect, useContext, useRef } from "react";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { GET_USER_DATA_BY_USERNAME } from "../../graphQL/register_qry";

import { project_url } from "../../constants/Data";

const useStyles = makeStyles(theme => ({
  textFieldInput: {
    height: "50px",
    maxHeight: "100px",
    width: "400px",
  },

  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
}));

function MemberTermAttendance() {
  const classes = useStyles();
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const { userUuid } = useParams();
  const { termUuid } = useParams();
  const { teamUuid } = useParams();

  const [fullName, setFullName] = useState("");

  const [termsAccess, setTermsAccess] = useState(true);

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");


  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Members",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');
      
      
      if(additionalActions.find(a => a == "Terms")){
        setTermsAccess(true);}
      else setTermsAccess(false);

      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);


  const [getUserDataByUserName] = useManualQuery(GET_USER_DATA_BY_USERNAME);

  const getDataList = async () => {
    // Get user information
    const {
      loading: userDataLoading,
      error: userDataError,
      data: userData,
    } = await getUserDataByUserName({
      variables: { username: userUuid },
    });
    if (!userDataLoading && userData && userData.getUserDataByUsername) {
      setFullName(
        userData.getUserDataByUsername.firstName +
          " " +
          userData.getUserDataByUsername.lastName
      );
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getDataList())();
  }, [userUuid]);

  if (loadContent)
    if (termsAccess)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: fullName, link: null },
            { label: "Terms List", link: `${project_url}/members/` + userUuid + "/terms" },
            { label: "Attendance", link: null },
          ]}
        />
        {/* <Header breadcrumbs={[
            { label: groupData.name, link: null },
            { label: "Permissions", link: null },
          ]} /> */}
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginTop: 10 }}>
              Under Development
            </Typography>
          </Box>
        </div>
      </div>
    );
    else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default MemberTermAttendance;
